import { ReactNode } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";

export const PageShell = ({ children }: { children: ReactNode }) => (
  <main className="min-h-screen bg-paper text-ink flex flex-col">
    <Navbar />
    <div className="flex-1">{children}</div>
    <Footer />
  </main>
);